import React from 'react';
import s from './index.scss';
function Loading(props) {
  return (
    <div
      className={s.loadingContainer}
      style={{
        position: props?.position_type ? `${props?.position_type}` : 'fixed'
      }}>
      <div className={s.contentBox}>
        <div className={s.circeTip}>
          <div className={s.circe}></div>
        </div>
        <div className={s.textTip}>
          loading
          <div className={s.textLoading}>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Loading;
